export default "__VITE_ASSET__DG035wKs__"